'use client'

import { BALANCER_POOL_ADDRESS, useBalancerPoolData } from '@/features/usdxl/logic/useBalancerPoolData'
import { useSummaryInfo } from '@/features/usdxl/logic/useSummaryInfo'
import { useUsdxlPoolAprBreakdown } from '@/features/usdxl/logic/useUsdxlPoolAprBreakdown'
import { Suspense } from 'react'
import { UsdxlCardContent } from './UsdxlCardContent'

function UsdxlCardContentLive() {
  const { isLoading, usdxlPrice, totalSupply, borrowAPY } = useSummaryInfo()
  const { apy: balancerApy } = useBalancerPoolData(BALANCER_POOL_ADDRESS)

  const { totalApr, balancerBaseApr } = useUsdxlPoolAprBreakdown({
    balancerApy,
  })

  return (
    <UsdxlCardContent
      isLoading={isLoading}
      usdxlPrice={usdxlPrice}
      totalSupply={totalSupply}
      borrowAPY={borrowAPY}
      poolTotalApr={totalApr}
      balancerPoolApr={balancerBaseApr}
    />
  )
}

export function UsdxlCardWrapper() {
  return (
    <Suspense fallback={<UsdxlCardContent isLoading={true} />}>
      <UsdxlCardContentLive />
    </Suspense>
  )
}
